import React from 'react'
import FS_CONTACTO_GPS_ICONO_2 from "../../../assets/img/FS-CONTACTO-GPS-ICONO-2.png";
import "./ContactBoxInf.scss";

const ContactBoxInf = ({adress, place}) => {
  return (
    <div className="contactBoxInf-container">
      <div className="contactBoxInf-icon-container">
        <img src={FS_CONTACTO_GPS_ICONO_2} alt="Contact" />
      </div>
      <div className="contactBoxInf-adress-container">
        <h4 className="t4 no-space mb-5">{place}</h4>
        <p className="body-16 no-space">{adress}</p>
      </div>
    </div>
  );
}

export default ContactBoxInf
